import { useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { EventIcon } from "@offstreetparking/design-system/icons/EventIcon";
import { ExternalLinkIcon } from "@offstreetparking/design-system/icons/ExternalLinkIcon";
import { Text } from "@offstreetparking/design-system/typography";
import { Heading } from "@offstreetparking/design-system/typography";
import { ViewMap } from "../ViewMap";
type ParkingLocationsProps = {
	venue: {
		centerLat?: string;
		centerLng?: string;
		addressLineOne?: string;
		addressLineTwo?: string;
		city?: string;
		state?: string;
		country?: string;
		postalCode?: string;
		useAddress?: boolean;
		name: string;
	};
};
export const ParkingVenue = ({ venue }: ParkingLocationsProps) => {
	const { t } = useLingui();
	return (
		<>
			<Heading As="h3" kind="h3">
				{t`Event Venue`}
			</Heading>
			<div className="space-y-3">
				<div className="rounded-md bg-neutral-faded p-4 [print-color-adjust:exact]">
					<div className="flex items-center gap-2">
						<AccessibleIcon>
							<EventIcon className="h-4 w-4" />
						</AccessibleIcon>
						<Text size="sm" weight="bold">
							{venue.name}
						</Text>
					</div>
					<div className="ml-6">
						<ViewMap place={venue} aria-label={`${t`Directions`} ${t`(opens in a new tab)`}`}>
							<Text As="span" size="sm" className="link">
								{t`Directions`}

								<span>
									<ExternalLinkIcon className="ml-0.5 inline h-3 w-3" />
								</span>
							</Text>
						</ViewMap>
					</div>
				</div>
			</div>
		</>
	);
};
